// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__PXyA2","previous":"Navigation_previous__oPKEP","noPrevious":"Navigation_noPrevious__Ob6jM"};